/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { IRemoteDto } from "./i-remote-dto";

export class EmailTemplateShortInfoRemoteDto implements IRemoteDto {
    id: number;
    name: string;
    from: string;
}
